import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import IsMobile from "../IsMobile";
import Subsection from "./Subsection";

function GraphSubsection(props) {
  function fullWidth() {
    return props.fullWidth || IsMobile();
  }
  const flexContainerClass = fullWidth()
    ? "GraphSubsection-fullWidthFlexContainer"
    : "GraphSubsection-flexContainer";

  const graphDescriptionClass = fullWidth()
    ? "GraphSubsection-fullWidthDescription"
    : "GraphSubsection-description";

  const graphContainerClass = fullWidth()
    ? "GraphSubsection-graphContainer"
    : "GraphSubsection-graphContainer GraphSubsection-desktopGraphContainer";

  const heightStyle = props.height ? { height: props.height } : {};

  return (
    <Subsection title={props.title}>
      <div className={flexContainerClass}>
        <div className={graphContainerClass} style={heightStyle}>
          {props.graph}
        </div>
        <div className={graphDescriptionClass}>
          <ReactMarkdown plugins={[gfm]} children={props.children} />
        </div>
      </div>
    </Subsection>
  );
}

export default GraphSubsection;
